import $ from "jquery";
import SortieCaisse from "@/components/caisse/caisse-sortie";
import ClotureCaisse from "@/components/caisse/caisse-cloture";
import PaiementDette from '@/components/caisse/caisse-paiement-dette';
import ModalConfirmationVersement from "@/components/caisse/modal-confirmation";
import DateFilter from '@/components/date-filter';
import DemandeAnnulation from '@/components/caisse/demande-annulation';
import ReferenceOperation from '@/components/caisse/reference-operation'
import CaisseInfo from '@/components/caisse/caisse-info'

import { openSelectOptions, cr_state } from "@/select-box.js";
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: "caisse",
    components: {
        SortieCaisse, ClotureCaisse,
        PaiementDette, ModalConfirmationVersement, DateFilter,
        DemandeAnnulation, ReferenceOperation, CaisseInfo
    },
    props: [],
    data() {
        return {
            user_role: 0,
            user_role_id: 0,
            compte_id: 0,
            user_id: 0,

            v: 0,
            vm_state: open_menu_state,
            jr_selected: "Aujourd'hui",
            curr_state: cr_state,

            statut_ouverture_caisse: '',
            isShow: false,
            operation_loading: true,
            operation_isempty: false,

            sortBy: 'created_at',
            sortKey: 'no',
            sortDesc: true,
            

            total_recettes: 0,
            total_depenses: 0,
            total_versements_faits: 0,
            total_versements_recus: 0,
            total_coupon_reduction: 0,
           
            caisseIsOpened: false,
            details_loading: true,
            details_depenses: [],
            choosen_date: '',
            montant_selectionne: 0,
            idOp_selected: 0,
            months: [
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],
            

            can_view_reglement_dette: false,
            d_modal_title: 'Sortie de caisse',
            rapport_versement: {},

            // ---------------------------------------------
            solde_courant: 0,
            open_loading: false,
            cash_register_is_closed: false,
            status_is_loading: true,
            is_error_load: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            filter_date: "",
            curr_month: "",
            date: new Date(),
            fields: [],
            perPage: -1,
            filter: "",
            currentPage: 1,
            total_pages: 0,

            operations_tobe_canceled: [],  // Opérations à annuler
            can_ask_cancelation: false,
            demand_toggler: 0,
            current_date_filter: {},
            reference_operation: {},
            op_info: {},

            recap_check_loading: true,
            solde_jour: 0,
            solde_jour_loading: true,

            operation_filters: [
                { id: 0, libelle: 'Tous', data_type: 'tous', is_op_caisse: 0 }, 
                { id: 1, libelle: 'Payées', data_type: '', is_op_caisse: 1 }, 
                { id: 2, libelle: 'Différées', data_type: '', is_op_caisse: 1 },
                { id: 3, libelle: 'Paiement partiel', data_type: '', is_op_caisse: 1 }, 
                { id: 0, libelle: 'Versement', data_type: 'versement', is_op_caisse: 0 },
                { id: 0, libelle: 'Annulation en attente', data_type: '', is_op_caisse: 2 },
                { id: 0, libelle: 'Annulation accordée', data_type: 'annulation', is_op_caisse: 0 },
                { id: 2, libelle: 'Annulation rejetée', data_type: '', is_op_caisse: 2 },
                { id: 0, libelle: 'Report de reliquat', data_type: 'reliquat', is_op_caisse: 0 },
                { id: 0, libelle: 'Règlement de reliquat', data_type: 'reglement_reliquat', is_op_caisse: 0 },
            ],
            filter_operation: { id: 0, libelle: 'Tous', data_type: 'tous', is_op_caisse: 0 },
            is_month: false,
            caisse_ops: []
        };
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                filter_option: this.filter_operation,
                page: 1
            }
            this.current_date_filter = data
            this.is_month = true
            this.getLigneOperationCaisse(data)
            this.getDdayBalance()
        },

        operations_tobe_canceled() {
            if (this.operations_tobe_canceled.length > 0) {
                this.can_ask_cancelation = true
            } else {
                this.can_ask_cancelation = false
            }
        },

        filter_operation() {
            this.operations_tobe_canceled = []
            
            this.current_date_filter.filter_option = this.filter_operation
            this.getLigneOperationCaisse(this.current_date_filter)
            this.getDdayBalance()
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index < this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        divers_info() {
            return this.$store.getters["divers_info"];
        },

        solde_du_jour() {
            return this.$store.getters["solde_du_jour"];
        },
    },

    async mounted() {
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
                this.can_view_reglement_dette = true
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            } else {
                this.compte_id = 0
            }

            if (this.activeRole.nom != 'ROLE_CAISSIERE' && this.activeRole.nom != 'ROLE_CAISSIERE_INTERMITENT') {
                this.$router.push({ "path": "/journal-caisse" })
            }
        } 

        if (this.can_set_pac) {
            this.fields = [
                { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, "date", 
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'pac', label: 'PA*' }, 
                { key: 'total_pac', label: 'TPA*' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ]
        } else {
            this.fields = [
                { key: 'choix_operation', label: '#' }, { key: 'ref', label: 'Référence' }, "date", 
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ]
        }

        this.$store.commit("SET_OPERATION_USER_COMPTE", []);
        this.$store.commit("SET_IS_CLOSING_CASH", false);

        // await this.getSoldeDisponible()
        await this.getCahRegisterStatus()


        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);

        //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });

        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("select-box")) {
                if (t.curr_state != 0) {
                    t.openSelectOption(t.curr_state, 'select-month')
                }
            }
        });

        $(".dropdown-el").click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass("expanded");
            $("#" + $(e.target).attr("for")).prop("checked", true);
        });
        $(document).click(function() {
            $(".dropdown-el").removeClass("expanded");
        });

        this.getDiversInfo()

        this.getDdayBalance()
    },

    methods: {
        getDdayBalance() {
            this.solde_jour_loading = true
            this.$store.dispatch("getSoldeDuJour", this.current_date_filter).then(() => {
                this.solde_jour = parseInt(this.solde_du_jour);
                this.solde_jour_loading = false
            })
        },

        getDiversInfo() {
            this.recap_check_loading = true
            this.$store.dispatch('getConfigInfoClinique', 'divers_info').then(() => {
                this.recap_check_loading = false
            })
        },

        viewRef(data) {
            if (data.data_type == 'annulation') {
                this.reference_operation = data.parent
            }

            if (data.etat_annulation == 1) {
                this.reference_operation = data.annulation_associee
            }
        },

        handleViewInfo(operation_info) {
            this.op_info = operation_info

            setTimeout(() => {
                $('.p-partiel-'+operation_info.id).modal('show')
            }, 200);
        },

        handleViewHistorique(operation_info) {
            this.op_info = operation_info

            setTimeout(() => {
                $('.v-historique-'+operation_info.id).modal('show')
            }, 200);
        },

        demandCancellation() {
            this.demand_toggler = (this.demand_toggler == 0)?1:0
        },

        getCahRegisterStatus() {
            this.status_is_loading = true
            const data = {
                compte_id: this.compte_id
            }

            this.current_date_filter = {
                compte_id: this.compte_id,
                user_id: this.user_id,
                month: "",
                one_date: this.getDates().today_date,
                from_date: "",
                to_date: ""
            }
            this.getSoldeDisponible(this.current_date_filter)
            this.$store.dispatch('getEtatOuvertureCaisse', data).then(() => {
                this.checkCahRegisterStatus()

                this.status_is_loading = false
            })
        },

        checkCahRegisterStatus() {
            if (this.etat_ouverture_caisse.close_status == 0) {
                this.cash_register_is_closed = false

                const data = {
                    compte_id: this.compte_id,
                    user_id: this.userCredentials.user.id,
                    month: "",
                    one_date: this.getDates().today_date,
                    from_date: "",
                    to_date: "",
                    filter_option: this.filter_operation,
                    page: 1
                }
                this.current_date_filter = data
                this.getLigneOperationCaisse(data)
            } else {
                this.cash_register_is_closed = true
                this.operation_loading = false
            }
        },

        getLigneOperationCaisse(data) {
            this.is_error_load = false
            this.operation_loading = true

            this.resetSoldeOperations()

            store_operation.selectOperationsCaisse(data).then((response) => {
                this.caisse_ops = response
                this.total_pages = response.last_page
                if (this.caisse_ops.data.length > 0) {
                    this.operation_isempty = false
                } else {
                    this.operation_isempty = true
                }
                this.operation_loading = false
            }).catch(() => {
                this.is_error_load = true
                this.operation_loading = false
            })
        },

        resetSoldeOperations() {
            this.total_recettes = 0
            this.total_depenses = 0
            this.total_versements_recus = 0
            this.total_versements_faits = 0
            this.total_coupon_reduction = 0
        },

        refreshOperationCaisse(date_filter) {
            this.operations_tobe_canceled = []
            this.can_ask_cancelation = false
            this.current_date_filter = date_filter
            this.getLigneOperationCaisse(date_filter)
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.userCredentials.user.id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                filter_option: this.filter_operation,
                page: 1
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getLigneOperationCaisse(data)
            this.getDdayBalance()
        },

        closeCashRegisterIfOpen() {
            this.getCahRegisterStatus()

            if (!this.cash_register_is_closed) {
                /**
                 * On verifie à ce niveau si la caisse a été ouverte mais n'a pas été 
                 * cloturé jusqu'à ce jouur. Si la caisse n'a pas été clôturée, 
                 * alors on cloture la caisse  sans versement puis on l'ouvre à nouveau
                */
                this.$store.dispatch('getDateOuvertureCaisseNonCloturee', this.compte_id).then((response) => {
                    const date_ouverture_anterieure = response

                    if (date_ouverture_anterieure != '') {
                        const data_cloture = {
                            user_id: this.user_id,
                            compte_id: this.compte_id,
                            solde_cloture: this.solde_disponible,
                            date_cloture: date_ouverture_anterieure
                        }

                        this.$store.dispatch('closeCaisse', data_cloture).then((response) => {
                            this.cash_register_is_closed = true
                            if (response.success) {
                                this.getCahRegisterStatus()
                            }
                        })
                    }
                })
            } else {
                this.operation_loading = false
            }
        },

        getSoldeDisponible(current_date_filter) {
            this.$store.dispatch("getSoldeDisponible", current_date_filter).then(() => {
                this.solde_courant = parseInt(this.solde_disponible);
            })
        },

        viewRapport(r) {
            this.rapport_versement = {
                solde_au_versement: r.solde_au_versement,
                erreur_caisse: r.erreur_caisse,
                commentaire: r.commentaire,
                montant_verse: parseInt(r.entree)
            }
            
        },

        ouvrirCaisse() {
            this.open_loading = true;

            this.$store.dispatch("getSoldeDisponible", this.current_date_filter).then(() => {
                this.solde_courant = parseInt(this.solde_disponible)

                const opening_data = {
                    compte_id: this.compte_id,
                    user_id: this.user_id,
                    solde_ouverture: this.solde_disponible
                }
          
                this.$store.dispatch('openCaisse', opening_data).then((response) => {
                    if (response.success) {
                        this.getCahRegisterStatus()
                    } else {
                        if (response.code === 409) {
                            this.warningToast("La caisse a été déjà ouverte !")
                        } else if (response.code === 403) {
                            const curr_caisse = (this.compte_id == 1)?'infirmière':'principale'
                            this.warningToast("La caisse "+curr_caisse+" est ouverte !")
                        }
                    }
                    this.open_loading = false;
                }).catch(() => {
                    this.open_loading = false;
                })
            })
        },

        ouvertureCaisse() {
            this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
                this.statut_ouverture_caisse = response
                this.isShow = true

                if (response == 0) {
                    this.$store.dispatch("getActiveCompteForUser", this.user_id).then(() => {
                        // card totaux datas
                        // this.makeStatsRequest(this.getDates().today_date)

                        setTimeout(() => {
                            if (this.operations.length > 0) {
                                this.open_loading = false;
                            } 
                        }, 1000);
                    });
                }
            });
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },
        updateDepense(mt) {
            this.total_depenses += parseInt(mt)
        },
        // update confirmation versement
        updateConfirmVersement(id_operation) {
            for (let index = 0; index < this.operations.length; index++) {
                if (this.operations[index].idOp == id_operation) {
                    this.operations[index].versement_confirm = true;
                    break;
                }
            }
        },
        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },


        /**
         * Show select options in dropdown
         * @param {int} j_state
         * @param {string} selector
         */
        openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector);
        },


        updateStatutCaisse(param) {
            this.statut_ouverture_caisse = param
        },

        getLignesDepenses(idOp) {
            this.details_loading = true;
            this.$store
                .dispatch("getLignesDepensesByIdOp", idOp)
                .then((response) => {
                    this.details_loading = false;
                    this.details_depenses = response;
                });
        },

        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        refreshCaisseOperation() {
            // TODO
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },
    },

};